import { yupResolver } from '@hookform/resolvers/yup'
import { Form } from 'antd'
import {
  InputTextField,
  InputTextAreaField,
  CustomMediaUploader,
  PrimaryButton,
  InputSelectField,
} from 'components'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { CompetitionTabScreen, EligibleCriteriaOptions } from 'utility'
import * as yup from 'yup'
import styled from 'styled-components'

const FormWrapper = styled.div`
  .custom-input {
    padding: 5px !important;
    background: #fafafa !important;
    border: 1px solid #b3b3b3 !important;
  }
`

export const RowWrapper = styled.div`
  display: flex;
  gap: 16px; /* Adjust the gap as needed */
`
const CompetitionsSchema = yup.object().shape({
  name: yup
    .string()
    .trim('Spaces not allowed')
    .strict()
    .required('name is required'),
  description: yup
    .string()
    .trim('Spaces not allowed')
    .strict()
    .required('description is required'),
  eligibility_criteria: yup
    .string()
    .trim('Spaces not allowed')
    .strict()
    .required('eligibility criteria is required'),
  rules: yup
    .string()
    .trim('Spaces not allowed')
    .strict()
    .required('rules is required'),
  participants_limit: yup
    .number()
    .strict()
    .required('participants limit is required'),

  price_details: yup.string().strict().required('price details is required'),
})

export const CompetitionsTabAddEdit = ({ onNext, data, setFiles, files, disable }) => {
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(CompetitionsSchema),
  })
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    if (data) {
      reset({
        ...data,
      })
      if (data.image) {
        setFiles([{ url: data.image, preview: data.image }])
      }
    }
  }, [data])
  const submit = async formData => {
    setLoading(true)
    try {
      onNext(CompetitionTabScreen.Common, {
        ...formData,
      })
    } catch (error) {
      console.log('error', error)
    } finally {
      setLoading(false)
    }
  }
  return (
    <FormWrapper>
      <Form disabled={disable}>
        <div className="row">
          <div className="col-8">
            <InputTextField
              required
              name="name"
              control={control}
              errors={errors}
              label="Name"
              placeholder="Name"
              className="custom-input"
            />
            <InputTextAreaField
              required
              name="description"
              control={control}
              errors={errors}
              label="Description"
              placeholder="Description"
            />
          </div>
          <div className="col-4">
            <CustomMediaUploader
              name="image"
              control={control}
              fileList={files}
              setFileList={setFiles}
            />
          </div>
        </div>
        <RowWrapper>
          <InputTextField
            required
            type="number"
            name="participants_limit"
            control={control}
            errors={errors}
            label="Participant Limit "
            placeholder="Participant Limit "
          />
          <InputTextField
            required
            // type="number"
            name="price_details"
            control={control}
            errors={errors}
            label="Price"
            placeholder="Enter Prize"
          />

          <InputSelectField
            name="eligibility_criteria"
            control={control}
            label="Eligible Criteria"
            options={EligibleCriteriaOptions}
            placeholder="Select Eligible Criteria"
            errors={errors}
            required
          />
        </RowWrapper>
        <InputTextAreaField
          required
          name="rules"
          control={control}
          errors={errors}
          label="Rules &  Guidelines"
          placeholder="Rules &  Guidelines"
        />
        <div className="d-flex justify-content-center my-3">
          <PrimaryButton loading={loading} onClick={handleSubmit(submit)}>
            Save & Next
          </PrimaryButton>
        </div>
      </Form>
    </FormWrapper>
  )
}
